var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFCF00;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.51,9.42H2.49C1.66,9.42,1,8.76,1,7.94V3.55c0-0.82,0.66-1.49,1.49-1.49h47.03c0.82,0,1.49,0.66,1.49,1.49 v4.39C51,8.76,50.34,9.42,49.51,9.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.24,49.94H11.76c-2.7,0-4.88-2.19-4.88-4.88L3.94,9.42h44.12l-2.94,35.63 C45.12,47.75,42.93,49.94,40.24,49.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.24,49.94H11.76c-2.7,0-4.88-2.19-4.88-4.88L3.94,9.42h44.12l-2.94,35.63 C45.12,47.75,42.93,49.94,40.24,49.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.51,9.42H2.49C1.66,9.42,1,8.76,1,7.94V3.55c0-0.82,0.66-1.49,1.49-1.49h47.03c0.82,0,1.49,0.66,1.49,1.49 v4.39C51,8.76,50.34,9.42,49.51,9.42z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26,
    cy: 29.68,
    r: 14.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.27,32.32c-0.02-0.27-0.11-0.64-0.27-1.11c-0.16-0.47-0.39-0.87-0.69-1.2c-0.3-0.33-0.75-0.68-1.34-1.04 c-0.6-0.36-1.32-0.66-2.16-0.88l-0.69-0.18v-4.05c0.32,0.09,0.6,0.27,0.85,0.56c0.36,0.42,0.55,0.93,0.57,1.54h3.21 c-0.09-1.48-0.6-2.61-1.51-3.39c-0.82-0.7-1.86-1.15-3.11-1.36v-1.81h-0.47h-1.33h-0.44v1.79c-1.28,0.16-2.38,0.61-3.29,1.36 c-1.01,0.83-1.51,1.97-1.51,3.44c0,0.72,0.12,1.35,0.36,1.88c0.24,0.53,0.6,0.96,1.07,1.29c0.47,0.33,0.94,0.6,1.4,0.79 c0.46,0.2,1.02,0.38,1.68,0.54c0.1,0.03,0.2,0.05,0.28,0.07v4.74c-0.52-0.17-0.97-0.46-1.32-0.87c-0.45-0.52-0.67-1.19-0.66-2 h-3.21c0.32,3.34,2.05,5.2,5.19,5.58v1.97h0.44h1.33h0.47v-1.97c0.67-0.08,1.29-0.22,1.85-0.44c0.69-0.26,1.23-0.57,1.63-0.93 c0.4-0.35,0.74-0.75,1.01-1.18c0.27-0.43,0.46-0.82,0.55-1.18c0.1-0.35,0.15-0.67,0.15-0.96C32.31,32.93,32.3,32.59,32.27,32.32z  M23.75,26.82c-0.31-0.27-0.46-0.66-0.46-1.15c0-0.6,0.2-1.07,0.6-1.39c0.29-0.23,0.62-0.38,0.99-0.45v3.53 C24.37,27.22,23.99,27.04,23.75,26.82z M28.36,34.76c-0.37,0.28-0.78,0.48-1.24,0.58v-4.13c0.67,0.21,1.16,0.43,1.44,0.68 c0.35,0.3,0.53,0.74,0.53,1.31C29.1,33.86,28.85,34.38,28.36,34.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26,44.31c-8.07,0-14.62-6.55-14.62-14.62c0-5.61,3.16-10.49,7.81-12.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26,15.07c8.07,0,14.62,6.55,14.62,14.62c0,5.59-3.14,10.45-7.75,12.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "17.53,14.35 21.38,15.8 19.92,19.65  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "34.5,45.06 30.66,43.61 32.12,39.76  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinance);
export default __webpack_public_path__ + "static/media/Refinance.f17e571bc8b93cd12c305cad6c38fd89.svg";
export { ForwardRef as ReactComponent };